import { ZoneService } from "./../_services/zone.service";
import { City } from "./../_models/city";
import { CityService } from "./../_services/city.service";
import { State } from "./../_models/state";
import { StateService } from "./../_services/state.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { environment } from "../../environments/environment";
import { Router } from "@angular/router";
import { Zone } from "../_models/zone";

@Component({
  selector: "app-add-city-page",
  templateUrl: "./add-city-page.component.html",
  styleUrls: ["./add-city-page.component.scss"],
})
export class AddCityPageComponent implements OnInit {
  public isModified = false;
  public city: City;
  public showAddContents = true;
  public states: State[];
  public zones: Zone[];

  constructor(
    private location: Location,
    public snackBar: MatSnackBar,
    public cityService: CityService,
    public stateService: StateService,
    public zoneService: ZoneService,
    private router: Router
  ) {}

  public back(): void {
    this.location.back();
  }

  public dataChanged(): void {
    this.isModified = true;
  }

  public getImageUrl(): string {
    return environment.imageUrl;
  }

  public ngOnInit(): void {
    this.zoneService.getZones().subscribe(
      (zones) => {
        this.zones = zones;
      },
      (err) => {
        this.showErrorMessage("Cannot retrieve zones");
      }
    );
    this.stateService.getStates().subscribe(
      (couriers) => {
        this.states = couriers;
      },
      (err) => {
        this.showErrorMessage("Cannot retrieve states");
      }
    );
    this.city = new City();
    this.city.stateId = 0;
    this.city.zoneId = 0;
  }

  isCityValid() {
    return this.city.name && this.city.code;
  }

  public save(): void {
    if (!this.isCityValid()) {
      this.showErrorMessage("Name or code is required");
      return;
    }

    this.cityService.addCity(this.city).subscribe(
      (state) => {
        this.showSuccessMessage("City was added successfully!");
        this.router.navigate(["regional", "cities"]);
      },
      (err) => {
        console.error(err);
        if (err.status == 400) {
          this.showErrorMessage("Invalid values");
        } else {
          this.showErrorMessage(
            "Sorry, your request cannot be process at the moment!"
          );
        }
      }
    );
  }

  public showErrorMessage(message): void {
    this.snackBar.open(message, "Error", {
      duration: 2000,
    });
  }

  public showSuccessMessage(message): void {
    this.snackBar.open(message, "Success", {
      duration: 2000,
    });
  }
}
